import React, { ReactNode } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Sidebar from '../sidebar';
import { PageActionSlotProvider } from '../ui/PageActionSlot';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '../ui/sidebar';

const Layout = ({ children }: { children: ReactNode }) => (
  <SidebarProvider>
    <Sidebar />
    <SidebarInset>
      <Flex h="56px" flexShrink={0} align="center" px="16px" display={{ base: 'flex', md: 'none' }}>
        <SidebarTrigger aria-label="Abrir menu lateral" />
      </Flex>
      <Box flex="1" minH={0} overflowY="auto">
        <Box
          maxW="1280px"
          mx="auto"
          px={{ base: '24px', sm: '32px', lg: '48px' }}
          py={{ base: '24px', sm: '32px', lg: '48px' }}
        >
          <PageActionSlotProvider>{children}</PageActionSlotProvider>
        </Box>
      </Box>
    </SidebarInset>
  </SidebarProvider>
);

export default Layout;
